/**
 * Thin analytics utility — fire-and-forget event tracking.
 *
 * Wraps window.landaiAnalytics if present (for future Segment / Amplitude
 * drop-in). Falls back to a no-op when no provider is configured (local
 * dev without GTM).
 *
 * Named exports so tests can spy on individual calls:
 *   import * as analytics from './analytics';
 *   jest.spyOn(analytics, 'trackEvent').mockImplementation(() => {});
 */

export function trackEvent(name, properties = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.landaiAnalytics === 'function') {
      window.landaiAnalytics(name, properties);
    }
    // Future drop-ins (uncomment when provider is wired):
    // if (window.gtag) window.gtag('event', name, properties);
    // if (window.analytics) window.analytics.track(name, properties);
  } catch {
    // Never let analytics calls throw into the caller.
  }
}
